export default [
  { value: 'Porch', label: 'Porch' },
  { value: 'Patio', label: 'Patio' },
  { value: 'Deck', label: 'Deck' },
  { value: 'Fence', label: 'Fence' },
];
